var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 332.16 32.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5b3d3a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.08,32.1C-1.69,21.54,24.51,8.34,58.6,2.63S121.76.84,123.53,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.09,31c1.63-10.59-24.75-23.43-58.91-28.68S210,1.38,208.37,12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset45);
export default __webpack_public_path__ + "static/media/Asset 45.3fccceff.svg";
export { ForwardRef as ReactComponent };